<template>
    <div>
        <div class="columns">
            <div class="column">
                <div class="level p-0 m-0">
                    <div class="level-left">
                        <div class="level-item">Lista e departamenteve</div>           
                    </div>
                    <div class="level-right">
                        <div class="level">
                            <a @click.prevent="create_department">
                                <span class="mr-2">Krijo</span>
                                <i class="fa fa-plus"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <table class="table mt-4">
                    <thead>
                        <tr>
                            <th>Kodi</th>
                            <th>Emri</th>
                            <th>Printeri</th>
                            <th>Modifiko</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dept in departments" :key="dept.guid || dept.id">
                            <td>{{dept.code}}</td>
                            <td>{{dept.name}}</td>
                            <td>{{dept.printer_ip}}</td>
                            <td><a href="" @click.prevent="edit_department(dept)"><i class="fa fa-pencil"></i></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="column is-5" v-if="form_edit || form_create">
                <DaForm v-if="form_create" :key="'create'" @submitted="submitDepartment" :form="form_create" />
                <DaForm v-if="form_edit" :key="'edit-' + (selectedDepartment.guid || '')" @submitted="submitDepartment" :form="form_edit" />
            </div>
        </div>
    </div>
</template>

<script>
import DaForm from "@/components/daform/index.vue";
import createDepartment from "./forms/create";
import editDepartment from "./forms/edit";
import DepartmentsServices from "@/services/Department";
export default {
components: {
    DaForm
},
data() {
    return {
        departments: [],
        selectedDepartment: {},
        form_create: null,
        form_edit: null,
    }
},
methods: {
    create_department() {
        this.form_edit = null
        this.form_create = createDepartment.form(this.route_param)
    },
    edit_department(de) {
        this.form_create = null
        this.form_edit = null
        setTimeout(() => {
            let form = editDepartment.form(de, this.route_param)

            this.form_edit = form
            this.selectedDepartment = de
        })
    },
    async submitDepartment(d) {
        const vendorId = this.route_param
        const isCreate = this.form_create != null
        try {
            if (isCreate) {
                await DepartmentsServices.createDepartment(d, vendorId)
            } else {
                d.guid = this.selectedDepartment.guid
                await DepartmentsServices.editDepartment(d, vendorId)
            }
            this.departments = await DepartmentsServices.getDepartments(vendorId)
            this.form_create = null
            this.form_edit = null
            if (this.$root && Object.prototype.hasOwnProperty.call(this.$root, 'selected_one')) {
                this.$root.selected_one = {}
            }
            this.$toast.success(isCreate ? "Departamenti u krijua me sukses" : "Departamenti u modifikua me sukses")
        } catch (err) {
            const message = err.response?.data?.message || (err.response?.data?.errors ? Object.values(err.response.data.errors).flat().join(" ") : null) || err.message || "Diçka shkoi keq. Provoni përsëri."
            this.$toast.error(message)
        }
    }
},

computed: {
    route_param() {
        return this.$route.params.vendor_id
    }
},
async created() {
    this.departments = await DepartmentsServices.getDepartments(this.route_param)
}
}
</script>

<style lang="scss" scoped>

</style>